{
  "version": 1,
  "asset_id": "04744a83-4e62-4943-bced-5f485563d252",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/04744a83-4e62-4943-bced-5f485563d252/ind-professional-services-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/04744a83-4e62-4943-bced-5f485563d252/ind-professional-services-640.avif",
  "original_filename": "ind-professional-services-640.avif",
  "size": 5329,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:10Z"
}
